<template>
    <div v-if="stats.length" class="bg-white py-12 sm:py-16">
        <Container>
            <dl class="grid grid-cols-1 gap-6 sm:grid-cols-3">
                <div v-for="stat in stats" :key="stat.id"
                    class="rounded-2xl bg-primary-50/70 px-6 py-10 text-center ring-1 ring-inset ring-primary-100">
                    <dd class="text-4xl font-semibold tracking-tight text-primary-700 sm:text-5xl">{{ stat.value }}</dd>
                    <dt class="mt-2 text-sm font-medium text-gray-600">{{ stat.name }}</dt>
                </div>
            </dl>
        </Container>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axios from 'axios';
import Container from '@/components/ui/Container.vue';

const stats = ref([]);

onMounted(async () => {
    const response = await axios.get('/api/stats');
    stats.value = response.data.data;
});
</script>
